import { useEffect, useRef } from 'react';
import { exampleResponses } from '../../../mocks/landingData';

export default function ExampleInteractionSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate-slide-up');
          }
        });
      },
      { threshold: 0.1 }
    );

    const section = sectionRef.current;
    if (section) {
      const elements = section.querySelectorAll('.animate-on-scroll');
      elements.forEach((el) => observer.observe(el));
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="relative py-20 md:py-28 bg-midnight">
      <div className="absolute inset-0 bg-gradient-to-b from-midnight via-royal-navy/10 to-midnight" />
      <div className="absolute top-1/3 left-1/3 w-96 h-96 rounded-full bg-champagne-gold/3 blur-3xl" />

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <div className="animate-on-scroll opacity-0 inline-flex items-center gap-2 px-4 py-2 rounded-full border border-champagne-gold/30 bg-champagne-gold/10 mb-6">
              <i className="ri-message-3-line text-champagne-gold text-sm" />
              <span className="text-champagne-gold text-sm font-medium">Example</span>
            </div>

            <h2 className="animate-on-scroll opacity-0 font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-warm-white mb-6">
              See how TNT Coach AI{' '}
              <span className="gold-gradient-text">works.</span>
            </h2>
          </div>

          <div className="animate-on-scroll opacity-0 bg-royal-navy/20 rounded-2xl p-6 md:p-8 border border-champagne-gold/20 mb-8">
            <div className="flex items-start gap-3 mb-2">
              <div className="w-8 h-8 rounded-full bg-metallic-gold/20 flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-user-3-line text-champagne-gold text-sm" />
              </div>
              <div>
                <p className="text-champagne-gold text-sm font-semibold mb-1">Your question:</p>
                <p className="text-warm-white text-base italic">
                  "I want to start my business, but I keep procrastinating and doubting myself."
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {exampleResponses.map((response, index) => (
              <div
                key={index}
                className="animate-on-scroll opacity-0 p-5 rounded-xl bg-midnight border border-royal-navy/30 hover:border-champagne-gold/30 transition-all duration-300 card-hover"
              >
                <div className="flex items-center gap-2 mb-3">
                  <div className="w-8 h-8 rounded-full gold-gradient flex items-center justify-center">
                    <i className="ri-sparkling-line text-midnight text-sm" />
                  </div>
                  <span className="text-champagne-gold text-sm font-semibold">{response.style}</span>
                </div>
                <p className="text-silver-grey text-sm leading-relaxed">{response.response}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}